import { Component, ReactNode } from 'react';

import { I18nProvider, useTranslation } from '@eneco/i18n';
import { NotificationBox } from '@eneco/sparky';

interface Props {
  children: ReactNode;
  componentName: string;
}

interface State {
  hasError: boolean;
}

function TranslationFallback() {
  const { t } = useTranslation();
  return <NotificationBox isAlert={true} text={t('errorBoundary.fallbackMessage')} />;
}
class WithErrorLogging extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  override render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <I18nProvider dictionary={locale => import(`./../content/${locale}.json`)}>
          <TranslationFallback />
        </I18nProvider>
      );
    }

    return children;
  }
}

export default WithErrorLogging;
